/* HH product page (B1, 2026-10-19) — loaded with defer from sections/main-product.liquid.
   1) Sticky bar never covers the product title or price: while either of them sits in the bottom band where the bar would
      appear, body gets .hh-sticky-hold and the bar waits (CSS in assets/hh-pdp.css). The theme still decides when the bar
      is wanted (body.sticky-shown: main add button out of view); this only adds "not on top of the title/price".
   2) The bar's short variant label follows the selected variant (picked in the page or in the bar's own select).
   No cart or tracking code here: the bar's form and button are the theme's own. */
(() => {
  const sticky = document.querySelector('hdt-sticky-btn-atc.hh-sticky');
  if (!sticky) return;
  const body = document.body;
  const title = document.querySelector('.hdt-product__title');
  // fix 2 (2026-10-19): the price block now also holds the instalment / after-code lines; only the price row itself makes the bar wait
  const price = document.querySelector('.hdt-product__price .hdt-price-wrapp') || document.querySelector('.hdt-product__price');
  let raf = 0;
  const check = () => {
    raf = 0;
    const vh = window.innerHeight;
    const band = (sticky.offsetHeight || 72) + 8;
    let hold = false;
    for (const el of [title, price]) {
      if (!el) continue;
      const r = el.getBoundingClientRect();
      if (r.height > 0 && r.top < vh && r.bottom > vh - band) { hold = true; break; }
    }
    body.classList.toggle('hh-sticky-hold', hold);
  };
  const schedule = () => { if (!raf) raf = requestAnimationFrame(check); };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  check();
  body.classList.add('hh-sticky-ready');
  // fonts / images above the title can still move it right after load
  window.addEventListener('load', schedule);
  setTimeout(schedule, 1500);

  const select = sticky.querySelector('[tag-select]');
  const label = sticky.querySelector('.hh-sticky__variant-txt');
  if (select && label) {
    const sync = () => {
      const o = select.options[select.selectedIndex];
      if (o) label.textContent = o.getAttribute('data-title') || o.textContent.trim();
    };
    select.addEventListener('change', sync);
    const form = document.forms[sticky.getAttribute('form')];
    if (form) form.addEventListener('variant:change', () => setTimeout(sync, 0));
  }
})();
